import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignmentLeftBar: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="alignment-left-bar"><path d="M2.75 4.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 6.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 12H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.75 17.75H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconAlignmentLeftBar;
